import { ProductTypeEnum, defaultECourseValues } from '@systemeio/digital-store-shared'
import { ProductECourseItemEditType } from 'modules/stores/store/content/product/types/product-interface'

export const defaultValues: ProductECourseItemEditType = {
  ...defaultECourseValues,
  draft: false,
  productType: ProductTypeEnum.eCourse,
  checkoutPage: {
    fields: [],
    title: '',
    buttonTitle: '',
    description: '',
    cover: null,
    offerId: null,
    digitalProductId: undefined,
  },
  thankYouPage: {
    title: 'ThankYouTitle',
    text: 'ThankYouText',
  },
  courseId: undefined,
}
